




































import Vue from "vue";
import { ConnectedDevice } from "../../models/ConnectedDevice";

export default Vue.extend({
  props: {
    name: {
      type: String,
      default: "ConnectedDeviceForm"
    },
    settingData: {
      type: Object as () => ConnectedDevice,
      default: null
    }
  },
  methods: {
    handleSubmit(e: Event) {
      e.preventDefault();
      this.$emit("submit", this.settingData);
    },
    getModeName(code) {
      switch (code) {
        case 1:
          return "Master";
        case 2:
          return "Slave";
        case 3:
          return "KDS";
        case 4:
          return "Table Ordering";
        case 5:
          return "Customer Screen";
        case 6:
          return "ANZ Blade";
        default:
          break;
      }
    }
  }
});
